import { render, staticRenderFns } from "./HeadacheItem.vue?vue&type=template&id=d8539406&scoped=true&"
import script from "./HeadacheItem.vue?vue&type=script&lang=js&"
export * from "./HeadacheItem.vue?vue&type=script&lang=js&"
import style0 from "./HeadacheItem.vue?vue&type=style&index=0&id=d8539406&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8539406",
  null
  
)

export default component.exports